import { responsive } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";

export const containerStyle = recipe({
  base: {
    borderRadius: theme.borderRadiuses.onS,
    backgroundColor: theme.colors.secondary,
    width: "100%",
    ...responsive({
      base: {
        padding: theme.spacings.s,
      },
      s: {
        padding: theme.spacings.m,
      },
    }),
  },
  variants: {
    variant: {
      primary: {
        backgroundColor: theme.colors.panel,
      },
      secondary: {
        backgroundColor: theme.colors.background,
      },
    },
  },
});

export const headerStyle = recipe({
  base: {
    width: "100%",
  },
});
